import { render, staticRenderFns } from "./PageModeratorSponsorAdd.vue?vue&type=template&id=54f1a77c&"
import script from "./PageModeratorSponsorAdd.vue?vue&type=script&lang=js&"
export * from "./PageModeratorSponsorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
